import styled from 'styled-components';

import AppStatusStore from '@/stores/appStatus';
import AppActions from '@/actions/app';

import _Icon from '@repo/ui/components/ui/Icon';
import { kfSpin } from '../ui/Animations';
import { useStore } from '../../utils/alt';
import { GlobeTwoCancel } from '@nine-thirty-five/material-symbols-react/outlined';
import ConfirmModal from '../modals/Confirm';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

const Icon = styled(_Icon)`
  display: inline-block;
  animation-name: ${kfSpin};
  animation-duration: 5000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

const Alert = styled.div`
  background: #ffa647;
  color: white;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
  padding: 8px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  & svg {
    color: white;
  }
`;

function GlobalActivitySpinner() {
  const [{ isXhrActive, isNetworkOnline }] = useStore(AppStatusStore);
  const { t } = useTranslation(['commonPlat']);
  const handleNetworkInfo = useCallback(() => {
    AppActions.setModal({
      component: ConfirmModal,
      options: {
        title: t('common:errors.youAreOffline'),
        message: t('common:errors.offlineMessage'),
        confirmCaption: t('commonPlat:actions.okay'),
        hideCancel: true,
      },
    });
  }, [t]);
  if (!isXhrActive && isNetworkOnline) return null;

  return (
    <>
      {isXhrActive && (
        <div className="global-loader">
          <Icon name="loading" />
        </div>
      )}
      {!isNetworkOnline && (
        <Alert className="global-offline" onClick={handleNetworkInfo}>
          <_Icon name={GlobeTwoCancel} inverse style={{ marginRight: '8px' }} />{' '}
          {t('common:labels.noInternet')}
        </Alert>
      )}
    </>
  );
}

export default GlobalActivitySpinner;
